import { render, staticRenderFns } from "./CoFactorInput.vue?vue&type=template&id=c60d7862"
import script from "./CoFactorInput.vue?vue&type=script&lang=js"
export * from "./CoFactorInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports